import { Party } from '../../types/Party';
import { getConfig } from '../../config';

import { ActivityActions } from './activities';

const { batchWebURL } = getConfig();

export const EXPIRED_MEMBER_INVITED_DAYS = 5;

export const PARTIES_CSV_HEADERS = [
  { label: 'Party Type', key: 'gender' },
  { label: 'Party Location', key: 'partyLocation' },
  { label: 'Party Start Date', key: 'startDate' },
  { label: 'Party End Date', key: 'endDate' },
  { label: 'Party Name', key: 'partyName' },
  { label: 'Party Description', key: 'partyDescription' },
  { label: 'Party Invite Code', key: 'inviteCode' },
  { label: 'Party Status', key: 'partyStatus' },
  { label: 'Party Creator User ID', key: 'userId' },
  { label: 'Party Creation Date', key: 'createdAt' },
  { label: 'Party ID', key: 'partyId' },
];

export const getPartyActions = (party: Party): ActivityActions[] => {
  const { partyId } = party;

  return [
    {
      label: 'View on web',
      image: { src: '/copy-square.png', alt: 'bach-web-link', width: '20px' },
      type: 'link',
      href: `${batchWebURL}/parties/${partyId}`,
      show: !!partyId,
    },
    {
      label: 'Copy party deeplink',
      image: { src: '/copy-icon.svg', alt: 'page-deep-link', width: '20px' },
      type: 'button',
      href: `${batchWebURL}/parties/${partyId}`,
      show: !!partyId,
    },
  ];
};
